const getActions = (states) => {
  const keys = Object.keys(states);

  const actionsObject = keys.reduce((actions, value) => {
    const key = `set${value.charAt(0).toUpperCase() + value.slice(1)}`;
    actions[key] = ({ commit }, val) => commit(
      `SET_${value.split(/(?=[A-Z])/).join('_').toUpperCase()}`, val,
    );
    return actions;
  }, {});

  return actionsObject;
};

const getGetters = (states, key) => {
  const keys = Object.keys(states);
  const gettersObject = keys.reduce((actions, value) => {
    actions[value] = state => state[key][value] || states[value];
    return actions;
  }, {});

  return gettersObject;
};

const getMutations = (states, key) => {
  const keys = Object.keys(states);

  const mutationsObject = keys.reduce((actions, value) => {
    const set = `SET_${value.split(/(?=[A-Z])/).join('_').toUpperCase()}`;
    const unset = `UN${set}`;
    actions[set] = (state, val) => { state[key][value] = val; };
    actions[unset] = (state) => { state[key][value] = undefined; };
    return actions;
  }, {});

  return mutationsObject;
};

export default {
  getActions,
  getGetters,
  getMutations,
};
